import { useState } from 'react'
import { SettingsButton } from './SettingsButton/SettingsButton'
import { useCurrentUserInformation } from 'shared/hooks/useCurrentUserInformation'
import { SettingsDialog } from './SettingsDialog'

interface SettingsSelectProps {

}

export const SettingsSelect = (props: SettingsSelectProps): JSX.Element => {
    const [open, setOpen] = useState<boolean>(false)
    const [settingsButtonRef, setSettingsButtonRef] = useState<HTMLElement | null>(null)
    const { userInformation } = useCurrentUserInformation()

    const handleSettingsButtonClick = (event: any) => {
        setOpen((prev: boolean) => !prev)
    }

    const handleSettingsButtonCaption = () => {
        if (userInformation === undefined) {
            return (``)
        }

        return userInformation.name[0].toUpperCase()
    }

    const handleSettingsButtonRef = (event: any) => {
        setSettingsButtonRef(event)
    }

    const handleDialogClose = (event: any) => {
        setOpen(false)
    }

    const caption = handleSettingsButtonCaption()

    return (
        <>
            <SettingsButton
                onClick={handleSettingsButtonClick}
                caption={caption}
                ref={handleSettingsButtonRef}
            />
            <SettingsDialog 
                open={open}
                anchorElement={settingsButtonRef}
                onClose={handleDialogClose}
            />
        </>
    )
}